// import React, { useState, useEffect } from "react";
// import { FaFolder, FaFileDownload } from "react-icons/fa";
// import axios from "axios";

// const DocumentExplorer = () => {
//   const [openFolders, setOpenFolders] = useState({ mspl_documents: {}, pdi_witness: {} });
//   const [documents, setDocuments] = useState({ mspl_documents: {}, pdi_witness: {} });

//   // Automatically open folder based on viewUniqueId
//   useEffect(() => {
//     const viewUniqueId = localStorage.getItem("viewUniqueId");
//     if (viewUniqueId) {
//       setOpenFolders((prev) => ({
//         ...prev,
//         mspl_documents: { ...prev.mspl_documents, [viewUniqueId]: true },
//         pdi_witness: { ...prev.pdi_witness, [viewUniqueId]: true },
//       }));
//     }
//   }, [documents]);

//   // Fetch documents on component load
//   useEffect(() => {
//     const fetchDocuments = async () => {
//       try {
//         const projectId = localStorage.getItem("selectedProject");
//         const response = await axios.post("https://redoms-backend-dev.m-devsecops.com/get_supported_document", { projectId });
//         setDocuments(response.data.documents_by_supplier);
//       } catch (error) {
//         console.error("Error fetching documents:", error);
//       }
//     };
//     fetchDocuments();
//   }, []);

//   const toggleFolder = (section, folderId) => {
//     setOpenFolders((prev) => ({
//       ...prev,
//       [section]: {
//         ...prev[section],
//         [folderId]: !prev[section][folderId],
//       },
//     }));
//   };

//   const downloadFile = async (filename) => {
//     const projectId = parseInt(localStorage.getItem("selectedProject")); // Ensure projectId is an integer
//     try {
//       const response = await axios.post(
//         "https://redoms-backend-dev.m-devsecops.com/download_supported_document",
//         { projectId, fileName: filename },
//         { responseType: "blob" }
//       );

//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", filename);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//     } catch (error) {
//       console.error("Error downloading file:", error);
//     }
//   };

//   const renderFolder = (section, folderId, files) => (
//     <div key={folderId} className="mb-4">
//       <div
//         onClick={() => toggleFolder(section, folderId)}
//         className="cursor-pointer flex items-center bg-gray-200 p-2 rounded hover:bg-gray-300"
//       >
//         <FaFolder className="mr-2 text-yellow-500" />
//         <span className="font-semibold">{folderId}</span>
//       </div>
//       {openFolders[section][folderId] && (
//         <div className="mt-2">
//           {files.map((fileName, index) => (
//             <button
//               key={index}
//               onClick={() => downloadFile(fileName)}
//               className="flex items-center p-2 text-gray-600 hover:underline"
//             >
//               <FaFileDownload className="mr-2" />
//               {fileName}
//             </button>
//           ))}
//         </div>
//       )}
//     </div>
//   );

//   const renderDocumentsSection = (title, sectionKey, documentData) => (
//     <div className="mb-8">
//       <h2 className="text-xl font-bold mb-4">{title}</h2>
//       <div className="border rounded-lg p-4 bg-white shadow">
//         {Object.entries(documentData).map(([supplierName, folders]) => (
//           <div key={supplierName}>
//             <h3 className="text-lg font-semibold mb-2">{supplierName}</h3>
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
//               {Object.entries(folders).map(([uniqueId, files]) => renderFolder(sectionKey, uniqueId, files))}
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );

//   return (
//     <div className="p-6 bg-gray-100 min-h-screen">
//       {renderDocumentsSection("Documents from PDI Review TPI", "pdi_witness", documents.pdi_witness)}
//       {renderDocumentsSection("Supported Documents MSPL", "mspl_documents", documents.mspl_documents)}
//     </div>
//   );
// };

// export default DocumentExplorer;

import React, { useState, useEffect, useMemo } from "react";
import { FaFolder, FaFileDownload, FaSearch, FaChevronDown, FaExclamationCircle } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import debounce from "lodash/debounce";
import { Tooltip } from "react-tooltip";

const DocumentExplorer = () => {
  const [openFolders, setOpenFolders] = useState({ mspl_documents: {}, pdi_witness: {} });
  const [documents, setDocuments] = useState({ mspl_documents: {}, pdi_witness: {} });
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  // Fetch documents
  useEffect(() => {
    const fetchDocuments = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const projectId = localStorage.getItem("selectedProject");
        const response = await axios.post(`${baseURL}get_supported_document`, { projectId });
        setDocuments(response.data.documents_by_supplier || { mspl_documents: {}, pdi_witness: {} });
      } catch (error) {
        setError("Failed to load documents. Please try again later.");
        console.error("Error fetching documents:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchDocuments();
  }, [baseURL]);

  // Auto-open folder based on viewUniqueId
  useEffect(() => {
    const viewUniqueId = localStorage.getItem("viewUniqueId");
    if (viewUniqueId && documents) {
      setOpenFolders((prev) => ({
        ...prev,
        mspl_documents: { ...prev.mspl_documents, [viewUniqueId]: true },
        pdi_witness: { ...prev.pdi_witness, [viewUniqueId]: true },
      }));
    }
  }, [documents]);

  const toggleFolder = (section, folderId) => {
    setOpenFolders((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [folderId]: !prev[section][folderId],
      },
    }));
  };

  const downloadFile = async (filename) => {
    const sanitizedFilename = filename.replace(/[^a-zA-Z0-9_\-. ]/g, "");
    if (!sanitizedFilename) return;

    try {
      const projectId = localStorage.getItem("selectedProject");
      const response = await axios.post(
        `${baseURL}download_supported_document`,
        { projectId, fileName: sanitizedFilename },
        { responseType: "blob" }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = sanitizedFilename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const handleSearch = debounce((value) => {
    setSearchQuery(value);
  }, 300);

  // Highlight search term
  const highlightText = (text, query) => {
    if (!query) return text;
    const parts = text.split(new RegExp(`(${query})`, "gi"));
    return parts.map((part, i) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <mark key={i} className="bg-yellow-200 text-yellow-900 px-1 rounded">
          {part}
        </mark>
      ) : (
        part
      )
    );
  };

  const filteredDocuments = useMemo(() => {
    if (!searchQuery.trim()) return documents;

    const filterSection = (section) => {
      const filtered = {};
      for (const [supplier, folders] of Object.entries(section)) {
        const filteredFolders = {};
        for (const [folderId, files] of Object.entries(folders)) {
          const matchingFiles = files.filter((file) =>
            file.toLowerCase().includes(searchQuery.toLowerCase())
          );
          if (matchingFiles.length > 0) {
            filteredFolders[folderId] = matchingFiles;
          }
        }
        if (Object.keys(filteredFolders).length > 0) {
          filtered[supplier] = filteredFolders;
        }
      }
      return filtered;
    };

    return {
      mspl_documents: filterSection(documents.mspl_documents),
      pdi_witness: filterSection(documents.pdi_witness),
    };
  }, [searchQuery, documents]);

  const renderFileItem = (fileName, index) => {
    const displayName = fileName.length > 40 ? fileName.slice(0, 37) + "..." : fileName;

    return (
      <motion.button
        key={index}
        initial={{ opacity: 0, x: -10 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: index * 0.05 }}
        onClick={() => downloadFile(fileName)}
        className="group w-full flex items-center justify-between p-3 rounded-lg bg-gray-50 hover:bg-blue-50 border border-gray-200 transition-all duration-200"
        data-tooltip-id={`tooltip-${fileName}`}
      >
        <div className="flex items-center flex-1 min-w-0">
          <FaFileDownload className="mr-3 text-blue-600 flex-shrink-0" />
          <span className="text-sm font-medium text-gray-700 truncate">
            {highlightText(displayName, searchQuery)}
          </span>
        </div>
        <span className="ml-2 text-xs text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity">
          Download
        </span>
        <Tooltip id={`tooltip-${fileName}`} place="top" content={fileName} />
      </motion.button>
    );
  };

  const renderFolder = (section, folderId, files) => (
    <motion.div
      layout
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.3 }}
      className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-300"
    >
      <div
        onClick={() => toggleFolder(section, folderId)}
        className="cursor-pointer p-5 flex items-center justify-between bg-gray-200 transition-all"
      >
        <div className="flex items-center">
          <motion.div
            animate={{ rotate: openFolders[section][folderId] ? 0 : -90 }}
            transition={{ duration: 0.2 }}
          >
            <FaChevronDown className="mr-3 text-gray-600" />
          </motion.div>
          <FaFolder className="mr-3 text-yellow-500 text-xl" />
          <span className="font-semibold text-gray-800 text-sm">{folderId}</span>
          <span className="ml-2 text-xs text-gray-500 bg-white px-2 py-1 rounded-full">
            {files.length} file{files.length > 1 ? "s" : ""}
          </span>
        </div>
      </div>

      <AnimatePresence>
        {openFolders[section][folderId] && (
          <motion.div
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="p-4 space-y-2 bg-gray-50"
          >
            {files.length > 0 ? (
              files.map((file, idx) => renderFileItem(file, idx))
            ) : (
              <p className="text-center text-gray-400 text-sm py-4">No files in this folder</p>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );

  const renderDocumentsSection = (title, sectionKey, documentData) => {
    const hasData = Object.keys(documentData).length > 0;

    if (!hasData) return null;

    return (
      <motion.section
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="mb-16"
      >
        <h2 className="text-3xl font-bold text-gray-800 mb-8 flex items-center">
          <span className="mr-3 text-4xl">📄</span> {title}
        </h2>

        {Object.entries(documentData).map(([supplierName, folders]) => (
          <div key={supplierName} className="mb-10">
            {/* <h3 className="text-xl font-semibold text-gray-700 mb-5 flex items-center">
              <span className="w-2 h-2 bg-gray-600 rounded-full mr-3"></span>
              {supplierName}
            </h3> */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {Object.entries(folders).map(([uniqueId, files]) =>
                renderFolder(sectionKey, uniqueId, files)
              )}
            </div>
          </div>
        ))}
      </motion.section>
    );
  };

  const totalFiles = Object.values(filteredDocuments).reduce(
    (acc, section) =>
      acc +
      Object.values(section).reduce(
        (sum, folders) => sum + Object.values(folders).flat().length,
        0
      ),
    0
  );

  return (
    <>
      <div className="w-full rounded-md p-4 sm:p-6 lg:p-8">
        <div className="w-full mx-auto">
          {/* Header */}
          {/* <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-10"
          >
            <h1 className="text-4xl font-bold text-gray-800 mb-2">Supported Documents</h1>
            <p className="text-gray-600">Browse and download project documents securely</p>
          </motion.div> */}

          {/* Search Bar */}
          <div className="mb-10">
            <div className="relative max-w-2xl mx-auto">
              <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg" />
              <input
                type="text"
                placeholder="Search across all documents..."
                onChange={(e) => handleSearch(e.target.value)}
                className="w-full pl-12 pr-6 py-4 rounded-2xl border border-gray-200 focus:outline-none focus:ring-4 focus:ring-blue-200 focus:border-blue-500 shadow-lg transition-all text-lg"
              />
              {searchQuery && (
                <motion.button
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  onClick={() => {
                    setSearchQuery("");
                    handleSearch("");
                  }}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  ✕
                </motion.button>
              )}
            </div>
            {searchQuery && (
              <p className="text-center mt-3 text-sm text-gray-600">
                Found <strong>{totalFiles}</strong> file{totalFiles !== 1 ? "s" : ""} matching "
                <em>{searchQuery}</em>"
              </p>
            )}
          </div>

          {/* Loading State */}
          {isLoading && (
            <div className="flex flex-col items-center py-20">
              <div className="animate-spin rounded-full h-16 w-16 border-4 border-indigo-200 border-t-indigo-600"></div>
              <p className="mt-6 text-lg text-gray-600">Loading your documents...</p>
            </div>
          )}

          {/* Error State */}
          {error && (
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              className="bg-red-50 border-l-4 border-red-500 p-6 rounded-xl mb-8 flex items-center"
            >
              <FaExclamationCircle className="text-red-600 text-2xl mr-4" />
              <div>
                <p className="text-red-800 font-semibold">Error</p>
                <p className="text-red-700">{error}</p>
              </div>
            </motion.div>
          )}

          {/* Content */}
          {!isLoading && !error && (
            <>
              {renderDocumentsSection(
                "PDI Review TPI Documents",
                "pdi_witness",
                filteredDocuments.pdi_witness
              )}
              {renderDocumentsSection(
                "MSPL Supported Documents",
                "mspl_documents",
                filteredDocuments.mspl_documents
              )}

              {/* Empty State */}
              {totalFiles === 0 && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  className="text-center py-20"
                >
                  <div className="text-6xl mb-6">📂</div>
                  <h3 className="text-2xl font-semibold text-gray-700 mb-2">
                    {searchQuery ? "No matching documents" : "No documents available"}
                  </h3>
                  <p className="text-gray-500 max-w-md mx-auto">
                    {searchQuery
                      ? `Try adjusting your search term or clear the filter.`
                      : `This project doesn't have any documents yet.`}
                  </p>
                </motion.div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default DocumentExplorer;